module.exports = __webpack_public_path__ + "static/media/share-orchid.e1d7f287.svg";